import { Component, Input, Renderer2, OnDestroy } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-resume-preview',
  templateUrl: './resume-preview.component.html',
  styleUrls: ['./resume-preview.component.css']
})
export class ResumePreviewComponent implements OnDestroy {
  @Input() data;
  constructor(
    public activeModal: NgbActiveModal,
    private renderer: Renderer2
  ) {
    this.renderer.addClass(document.body, 'modal-preview');
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-preview');
  }
}
